import { SDQuerySubscribersStore, ClearConnectionResults } from "../SDQuerySubscribersStore";
export function unsubscribe(conn, r) {
    const x = SDQuerySubscribersStore.clearConnection(r);
    if (conn.isConnectedSync() &&
        x !== ClearConnectionResults.RemovedConnection &&
        x !== ClearConnectionResults.QueryNotFound) {
        conn.send({
            name: "Unsubscribe",
            params: { id: x }
        });
    }
    return x;
}
//# sourceMappingURL=Unsubscribe.js.map